import React from 'react';

const OtherPlatforms = () => {
  const platforms = [
{
id: 1,
title: 'Infrastructure Modernization',
description: 'Upgrade legacy environments with modern, scalable, and efficient infrastructure',
link: null,
icon: 'infrastructure',
color: 'purple',
isLink: true
},
{
id: 2,
title: 'Cloud Migration Services',
description: 'Move applications, databases, and workloads to reliable cloud environments',
link: null,
icon: 'cloud',
color: 'blue',
isLink: false,
buttonText: 'Request consultation →'
},
{
id: 3,
title: 'Managed Cloud Operations',
description: 'Ongoing monitoring, maintenance, and optimization for cloud infrastructure',
link: null,
icon: 'operations',
color: 'green',
isLink: false,
buttonText: 'Request consultation →'
}
];


  const relatedLinks = [
    { title: 'Proxmox Expertise', url: "#" },
    { title: 'VMware Migration Guide', url: "#" },
    { title: 'VMware to Proxmox Blog', url: "#" },
    { title: 'Hetzner Expertise', url: "#" }
  ];

  // Proxmox Icon (Server/Computer)
  const ProxmoxIcon = () => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      className="w-8 h-8 text-purple-600"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z" 
      />
    </svg>
  );

  // Cloud Icon (Building/Server)
  const CloudIcon = () => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      className="w-8 h-8 text-blue-600"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" 
      />
    </svg>
  );

  // Hybrid Icon (Layers/Cubes)
  const HybridIcon = () => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      className="w-8 h-8 text-green-600"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" 
      />
    </svg>
  );

  // Arrow Icon
  const ArrowIcon = () => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      className="w-4 h-4 text-gray-400 group-hover:text-purple-500 transition-colors"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" 
      />
    </svg>
  );

  const getIcon = (iconType) => {
    switch (iconType) {
      case 'proxmox':
        return <ProxmoxIcon />;
      case 'cloud':
        return <CloudIcon />;
      case 'hybrid':
        return <HybridIcon />;
      default:
        return <ProxmoxIcon />;
    }
  };

  const getButtonColor = (color) => {
    switch (color) {
      case 'purple':
        return 'text-purple-600 hover:text-purple-700';
      case 'blue':
        return 'text-blue-600 hover:text-blue-700';
      case 'green':
        return 'text-green-600 hover:text-green-700';
      default:
        return 'text-purple-600 hover:text-purple-700';
    }
  };

  const getHoverBorderColor = (color) => {
    switch (color) {
      case 'purple':
        return 'hover:border-purple-300';
      case 'blue':
        return 'hover:border-blue-300';
      case 'green':
        return 'hover:border-green-300';
      default:
        return 'hover:border-purple-300';
    }
  };

  return (
    <section 
      id="other" 
      className="py-5  transition-all duration-700 opacity-100 translate-y-0"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth="1.5" 
            stroke="currentColor" 
            className="w-12 h-12 text-gray-400 mx-auto mb-4"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" 
            />
          </svg>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Other Platforms &amp; Custom Scenarios
          </h2>
          <p className="text-gray-600">
            Not using one of the providers above? We also migrate:
          </p>
        </div>
        
        {/* Platforms Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          
          {platforms.map((platform) => {
            const buttonColor = getButtonColor(platform.color);
            const hoverBorderColor = getHoverBorderColor(platform.color);
            
            if (platform.isLink) {
              return (
                <a
                  key={platform.id}
                  className={`group bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-6 border border-gray-200 ${hoverBorderColor} hover:shadow-lg transition-all duration-300`}
                  href={platform.link}
                >
                  <div className="flex items-center gap-3 mb-3">
                    {getIcon(platform.icon)}
                    <ArrowIcon />
                    <span className="font-bold text-gray-900">{platform.title.split(' ')[0]}</span>
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{platform.title}</h3>
                  <p className="text-gray-600 text-sm mb-3">{platform.description}</p>
                </a>
              );
            }
            
            return (
              <div
                key={platform.id}
                className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-6 border border-gray-200"
              >
                <div className="flex items-center gap-3 mb-3">
                  {getIcon(platform.icon)}
                  <span className="font-bold text-gray-900">{platform.title.split(' ')[0]}</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{platform.title}</h3>
                <p className="text-gray-600 text-sm mb-3">{platform.description}</p>
                
              </div>
            );
          })}
          
        </div>
        
        
      </div>
    </section>
  );
};

export default OtherPlatforms;